import { useEffect, useState } from "react"
import { lumi } from "@/lib/lumi"

type AuthUser = {
  userId?: string
  email?: string
  userName?: string
  userRole?: string
} | null

export function useAuth() {
  const [user, setUser] = useState<AuthUser>(lumi.auth.user as AuthUser)
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    const syncUser = async () => {
      try {
        await lumi.auth.refreshUser()
      } catch {
        setUser(null)
      } finally {
        setUser(lumi.auth.user as AuthUser)
        setIsReady(true)
      }
    }

    void syncUser()

    const unsubscribe = lumi.auth.onAuthChange((_event, currentUser) => {
      setUser((currentUser as AuthUser) || null)
      setIsReady(true)
    })

    return () => {
      unsubscribe?.()
    }
  }, [])

  return { user, isReady, isAdmin: user?.userRole === "ADMIN" }
}
